/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_Kb_NoteInputs */

const en_mk_calc_row_kb_note = /** @type {(inputs: Mk_Calc_Row_Kb_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 99,000 per seat. Agent work is included up to the plan quota; agents themselves are not billable seats.`)
};

const id_mk_calc_row_kb_note = /** @type {(inputs: Mk_Calc_Row_Kb_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 99.000 per kursi. Kerja agen sudah termasuk sampai kuota paket; agen sendiri tidak dihitung sebagai kursi berbayar.`)
};

/**
* | output |
* | --- |
* | "Rp 99,000 per seat. Agent work is included up to the plan quota; agents themselves are not billable seats." |
*
* @param {Mk_Calc_Row_Kb_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_kb_note = /** @type {((inputs?: Mk_Calc_Row_Kb_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_Kb_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_kb_note(inputs)
	return en_mk_calc_row_kb_note(inputs)
});